import styles from "./TablePage.module.css";
import TableTemplate from "../../Templates/Table/TableTemplate/TableTemplate";
import TableLeftTemplate from "../../Templates/Table/TableLeftTemplate/TableLeftTemplate";
import TableRightTemplate from "../../Templates/Table/TableRightTemplate/TableRightTemplate";
import {TableRow, SortDirection, IReportAction} from "../../types/types.table";
import TableFilterTemplate from "../../Templates/Table/TableFilterTemplate/TableFilterTemplate";

interface ILoadParams {
  filters: Record<any, any>;
  sort: {
    column: string | null;
    direction: SortDirection;
  };
  pagination: {
    page: number;
    limit: number;
  };
}

type TemplateType = "default" | "left" | "right" | "filter";

interface DynamicTableProps<T extends Record<string, unknown>> {
  sortStateField?: string;
  loadData: (params: ILoadParams) => Promise<{ data: TableRow[]; total: number }>;
  saveData?: (params: TableRow) => Promise<any>;
  createData?: (params: Omit<TableRow, "id">) => Promise<any>;
  deleteData?: (params: TableRow) => Promise<any>;
  title?: string;
  module?: {
    id?: string | number;
    name?: string;
    description?: string;
    table_name?: string;
  };
  tableName: string;
  isReportMode?: boolean;
  fields: any[];
  maps?: Record<string, Record<string, string>>;
  template?: TemplateType;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  reportActions?: IReportAction[];
  reportActionCallBack?: (action: IReportAction, row: TableRow) => void;
}

export default function TablePage<T extends Record<string, unknown>>(props: DynamicTableProps<T>) {
  const template = props.template || "default";

  const templateProps = {
    loadData: props.loadData,
    saveData: props.saveData,
    createData: props.createData,
    deleteData: props.deleteData,
    title: props.title,
    fields: props.fields,
    maps: props.maps,
    sortStateField: props.sortStateField,
    isReportMode: !!props.isReportMode,
    reportActions: props.reportActions,
    reportActionCallBack: props.reportActionCallBack,
  };

  return (
    <div className={styles.container}>
      {template === "default" && props.module && (
        <TableTemplate
          module={{
            id: props.module.id,
            name: props.title || props.module.name || "",
            description: props.module.description
          }}
          {...templateProps}
        />
      )}
      
      {template === "left" && (
        <TableLeftTemplate {...templateProps} left={props.leftContent} />
      )}
      
      {template === "right" && (
        <TableRightTemplate {...templateProps} right={props.rightContent} />
      )}
      
      {template === "filter" && <TableFilterTemplate {...templateProps} />}
    </div>
  );
}